// extracted by mini-css-extract-plugin
export default {"vehicleGroupPanel":"VehicleGroupPanel_vehicleGroupPanel__CVFap","accordions":"VehicleGroupPanel_accordions__V3EDD"};